import {createGate} from 'effector-react';
import {createEffect, createEvent, createStore, sample} from 'effector';
import {getUserInfo, initApp, revokeTokens} from './utils.js';
import api from '../../api/api.js';

export const $authStatus = createStore(false)
export const $logoutDone = createStore(false)
export const $user = createStore(null)

export const LoginGate = createGate()

export const setAuthStatusEv = createEvent()

export const logoutEv = createEvent()

export const updateMyProfileEv = createEvent()
export const updateMyProfileFx = createEffect()
    .use(async (payload) =>  (await api().patch(`${SSO_BASE_URL}/api/v1/users/my/`, payload)).data)

export const confirmAuthFx = createEffect()
    .use(initApp)

export const getUserInfoFx = createEffect()
    .use(async (force) => await getUserInfo(force))

export const logoutFx = createEffect()
    .use(revokeTokens)

$authStatus.on(setAuthStatusEv, (state, payload) => payload)
    .on(confirmAuthFx.doneData, (state, payload) => payload)

$user.on(getUserInfoFx.doneData, (state, payload) => payload)

$logoutDone.on(logoutFx.doneData, (state, payload) => payload)

sample({
    clock: logoutEv,
    target: logoutFx
})

sample({
    source: $logoutDone,
    clock: LoginGate.open,
    filter: (logout) => !logout,
    target: confirmAuthFx
})

sample({
    clock: $logoutDone.updates,
    filter: (logout) => !!logout,
    fn: (logout) => !logout,
    target: setAuthStatusEv
})

sample({
    clock: $authStatus.updates,
    filter: status => !!status,
    target: getUserInfoFx
})

sample({
    clock: updateMyProfileEv,
    target: updateMyProfileFx
})

sample({
    clock: updateMyProfileFx.doneData,
    target: getUserInfoFx
})